<template>
  <div v-auto-animate class="consumption-inputs">
    <template v-if="localUsage.doubleMeter">
      <div class="electricity-field">
        <TextInput v-model.lazy="localUsage.electricity" class="text-input in-label electricity" type="number"
          inputmode="numeric" placeholder="Aantal kWh" label="Stroomverbruik normaal (kWh)" @keyup.enter="submit()" />
      </div>
      <div class="electricity-field">
        <text-input v-model.lazy="localUsage.electricityOffPeak" label="Stroomverbruik dal (kWh)"
          class="text-input in-label electricity" type="number" inputmode="numeric" placeholder="Aantal kWh"
          @keyup.enter="submit()" />
      </div>
    </template>
    <div v-else class="electricity-field">
      <TextInput v-model.lazy="localUsage.electricity" class="text-input in-label electricity" type="number"
        inputmode="numeric" placeholder="Aantal kWh" label="Stroomverbruik (kWh)" @keyup.enter="submit()" />
    </div>

    <div v-if="!localUsage.noGas" class="gas-field">
      <TextInput v-model.lazy="localUsage.gas" class="text-input in-label gas" type="number" inputmode="numeric"
        placeholder="Aantal m³" label="Gasverbruik (m³)" @keyup.enter="submit()" />
    </div>

    <CheckboxInput id="double-meter" v-model.lazy="localUsage.doubleMeter">
      Slimme meter met dubbel tarief
    </CheckboxInput>

    <CheckboxInput id="no-gas" v-model.lazy="localUsage.noGas">
      Alleen stroom
    </CheckboxInput>

    <CheckboxInput id="electricity-generated" v-model.lazy="localUsage.electricityGenerated">
      Zonnepanelen
    </CheckboxInput>

    <div v-if="localUsage.electricityGenerated" class="electricity-field">
      <TextInput v-model.lazy="localUsage.electricityGeneration" class="text-input in-label electricity" type="number"
        inputmode="numeric" placeholder="Aantal kWh" label="Totale teruglevering (kWh)" @keyup.enter="submit()" />
    </div>
    <ButtonNoIcon type="cta" label="Aanpassen" class="small-button" @click="submit()" />
  </div>
</template>
<script setup>
import { ref } from 'vue';
import TextInput from '../../../../vue-elements/input/TextInput.vue';
import CheckboxInput from '../../../../vue-elements/input/CheckboxInput.vue';
import ButtonNoIcon from '../../../../../abstracts/elements/button/no-icon/button-no-icon.vue';
import { useEnergyComparisonStore } from '../../stores/energyComparison';


const emits = defineEmits({
  close: null,
  submit: null,
});

const store = useEnergyComparisonStore();

const localUsage = ref({
  electricity: store.filters.electricity,
  electricityOffPeak: store.filters.electricityOffPeak,
  gas: store.filters.gas,
  electricityGenerated: store.filters.electricityGenerated,
  electricityGeneration: store.filters.electricityGeneration,
  doubleMeter: store.filters.doubleMeter,
  noGas: store.filters.noGas,
});

const close = () => {
  emits('close');
};

const submit = () => {
  updateUsage();
  close();
};

const updateUsage = () => {
  store.updateFilters(localUsage.value);
};

defineExpose({
  submit,
});

</script>
<style lang="scss">
@use 'assets/scss/all.scss' as *;

.consumption-inputs {
  @include flex-col-start;
  gap: 12px;

  .text-input {
    width: 100%;
  }

  .gas-field {
    margin-top: 0 !important;
  }

  .button-element {
    align-self: flex-end;
  }
}
</style>
